var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOnboardingRedesign)?_c('img',{attrs:{"src":require("@/assets/images/fsa-hsa/hsa-store-logo-purple.png")}}):_c('img',{attrs:{"src":require("@/assets/images/fsa-hsa/hsa-store-logo.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }